(() => {
  const updateNavigation = () => {
    const navigationLinks = document.querySelectorAll('[data-pb-nav-key]');
    const currentPath = window.location.pathname;
    const currentCategory = new URLSearchParams(window.location.search).get('category');

    navigationLinks.forEach((link) => {
      const destination = new URL(link.href, window.location.origin);
      const navigationKey = link.dataset.pbNavKey;
      let isCurrent = false;

      if (navigationKey === 'home') {
        isCurrent = currentPath === destination.pathname;
      } else if (navigationKey === 'parts') {
        isCurrent = currentPath === destination.pathname && currentCategory === 'parts';
      } else if (navigationKey === 'consumables') {
        isCurrent = currentPath === destination.pathname && currentCategory !== 'parts';
      } else {
        isCurrent = currentPath === destination.pathname;
      }

      link.classList.toggle('pb-header-navigation__link--active', isCurrent);

      if (isCurrent) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  updateNavigation();
  window.addEventListener('popstate', updateNavigation);
  window.addEventListener('pb:locationchange', updateNavigation);
})();

(() => {
  const categoryValues = ['all', 'parts', 'consumables', 'seeds', 'nutrients'];
  const lineValues = ['all', 'ORIGINAL', 'HALF', 'TABLE'];

  document.querySelectorAll('[data-pb-product-browser]').forEach((browser) => {
    const categoryButtons = browser.querySelectorAll('[data-pb-category-button]');
    const lineButtons = browser.querySelectorAll('[data-pb-line-button]');
    const lineFilters = browser.querySelector('[data-pb-line-filters]');
    const products = browser.querySelectorAll('[data-pb-product]');
    const count = browser.querySelector('[data-pb-product-count]');
    const emptyState = browser.querySelector('[data-pb-empty-state]');
    const resetButton = browser.querySelector('[data-pb-reset-filters]');

    const readLocation = () => {
      const parameters = new URLSearchParams(window.location.search);
      const requestedCategory = parameters.get('category');
      const requestedLine = parameters.get('line');
      const category = categoryValues.includes(requestedCategory) ? requestedCategory : 'all';
      const line = category === 'parts' && lineValues.includes(requestedLine) ? requestedLine : 'all';

      return { category, line };
    };

    let { category, line } = readLocation();

    const writeLocation = () => {
      const url = new URL(window.location.href);

      if (category === 'all') {
        url.searchParams.delete('category');
      } else {
        url.searchParams.set('category', category);
      }

      if (category === 'parts' && line !== 'all') {
        url.searchParams.set('line', line);
      } else {
        url.searchParams.delete('line');
      }

      window.history.pushState({}, '', url);
      window.dispatchEvent(new Event('pb:locationchange'));
    };

    const render = () => {
      let visibleProductCount = 0;

      categoryButtons.forEach((button) => {
        const isActive = button.dataset.pbCategoryButton === category;
        button.classList.toggle('pb-product-filter__button--active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (lineFilters) {
        lineFilters.hidden = category !== 'parts';
      }

      lineButtons.forEach((button) => {
        const isActive = button.dataset.pbLineButton === line;
        button.classList.toggle('pb-product-filter__button--active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      products.forEach((product) => {
        const matchesCategory = category === 'all' || product.dataset.pbCategory === category;
        const matchesLine = category !== 'parts' || line === 'all' || product.dataset.pbLine === line;
        const isVisible = matchesCategory && matchesLine;

        product.hidden = !isVisible;

        if (isVisible) {
          visibleProductCount += 1;
        }
      });

      if (count) {
        count.textContent = visibleProductCount;
      }

      if (emptyState) {
        emptyState.hidden = visibleProductCount !== 0;
      }
    };

    const applyFilter = (nextCategory, nextLine, updateUrl) => {
      category = nextCategory;
      line = category === 'parts' ? nextLine : 'all';
      render();

      if (updateUrl) {
        writeLocation();
      }
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.pbCategoryButton, 'all', true);
      });
    });

    lineButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter('parts', button.dataset.pbLineButton, true);
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        applyFilter('all', 'all', true);
      });
    }

    window.addEventListener('popstate', () => {
      const locationState = readLocation();
      applyFilter(locationState.category, locationState.line, false);
    });

    render();
  });
})();
